"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcOutlineSVGDrawer = void 0;
var tslib_1 = require("tslib");
var svgDrawer_1 = require("./svgDrawer");
var ArcOutlineSVGDrawer = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ArcOutlineSVGDrawer, _super);
    function ArcOutlineSVGDrawer() {
        return _super.call(this, "path", "arc outline") || this;
    }
    ArcOutlineSVGDrawer.prototype._applyDefaultAttributes = function (selection) {
        selection.style("fill", "none");
    };
    return ArcOutlineSVGDrawer;
}(svgDrawer_1.SVGDrawer));
exports.ArcOutlineSVGDrawer = ArcOutlineSVGDrawer;



//////////////////
// WEBPACK FOOTER
// ./src/drawers/arcOutlineDrawer.ts
// module id = 52
// module chunks = 0